import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const FooterVariant3 = ({ theme, font, editableData = {}, renderEditable }) => {
  const getText = (key, defaultValue) =>
    typeof editableData[key] === "string" ? editableData[key] : editableData[key]?.text || defaultValue;

  return (
    <footer
      className="px-8 py-12"
      style={{
        backgroundColor: theme.footerBackground,
        color: theme.footerTextColor,
        fontFamily: font.mainText,
      }}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Logo & About */}
        <div>
          <h2 className="text-2xl font-bold mb-4" style={{ color: theme.footerHeadingColor }}>
            {renderEditable ? renderEditable("brandName", getText("brandName", "BrandName")) : getText("brandName", "BrandName")}
          </h2>
          <p className="text-sm">
            {renderEditable
              ? renderEditable("about", getText("about", "Empowering developers with beautiful UI components and tools."))
              : getText("about", "Empowering developers with beautiful UI components and tools.")}
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4" style={{ color: theme.footerHeadingColor }}>
            {renderEditable ? renderEditable("quickLinksTitle", getText("quickLinksTitle", "Quick Links")) : getText("quickLinksTitle", "Quick Links")}
          </h3>
          <ul className="space-y-2">
            <li>
              <button className="hover:underline">
                {renderEditable ? renderEditable("link1", getText("link1", "Home")) : getText("link1", "Home")}
              </button>
            </li>
            <li>
              <button className="hover:underline">
                {renderEditable ? renderEditable("link2", getText("link2", "Docs")) : getText("link2", "Docs")}
              </button>
            </li>
            <li>
              <button className="hover:underline">
                {renderEditable ? renderEditable("link3", getText("link3", "Pricing")) : getText("link3", "Pricing")}
              </button>
            </li>
            <li>
              <button className="hover:underline">
                {renderEditable ? renderEditable("link4", getText("link4", "Blog")) : getText("link4", "Blog")}
              </button>
            </li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h3 className="text-xl font-semibold mb-4" style={{ color: theme.footerHeadingColor }}>
            {renderEditable ? renderEditable("followUs", getText("followUs", "Follow Us")) : getText("followUs", "Follow Us")}
          </h3>
          <div className="flex space-x-4">
            {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin].map((Icon, i) => (
              <a key={i} href="#" className="hover:scale-110 transition-transform duration-200">
                <Icon size={24} style={{ color: theme.primaryColor }} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 text-center border-t" style={{ borderColor: theme.footerDividerColor }}>
        <p className="text-sm">
          {renderEditable ? renderEditable("copyright", getText("copyright", "© 2025 BrandName. Crafted with care.")) : getText("copyright", "© 2025 BrandName. Crafted with care.")}
        </p>
      </div>
    </footer>
  );
};

export default FooterVariant3;
